export default __webpack_public_path__ + "static/media/specialilustration1.14e58437.svg";